module.exports = __webpack_public_path__ + "static/media/Anand.34a7caa4.jpg";